module.exports = __webpack_public_path__ + "img/d200803-2.25207b41.jpg";